import { Service } from "models/Service";

const WORLDCUP_SIMULATOR_PATH = "/worldcup-simulator/clarin/one-page";

function resolveIframeUrl() {
  const base = String(
    process.env.NEXT_PUBLIC_FRONT_HANDLER_URL || "https://sd-front.clarin.com",
  )
    .trim()
    .replace(/\/+$/, "");
  return `${base}${WORLDCUP_SIMULATOR_PATH}`;
}

export class WorldcupSimulator extends Service {
  constructor() {
    super({
      adsPath: "mundialfutbol-2026/home",
      meta: {
        description: "Simulador del Mundial - Clarín",
        keywords: "mundial, simulador, fútbol, clarín",
        title: "Simulador del Mundial",
        url: "simulador-mundial",
        extra: [],
      },
      section: "Servicios",
      sectionName: "Simulador Mundial",
      template: "WorldcupSimulator",
      title: "Simulador del Mundial",
      slug: "simulador-mundial",
      autorefresh: false,
      widthFull: true,
      bannersOn: true,
      serviceCcio: {
        sections: "simulador-mundial",
        nsSiteKey: "clarin-simulador-mundial",
      },
      sectionAds: "simulador-mundial",
      bannerFlotanteOff: [],
      bannerHorizontalOff: ["horizontal3"],
    });
  }

  parseData = async () => {
    const pageTitle = "Simulador del Mundial - Clarín";
    const pageDescription =
      "Probá el simulador del Mundial de fútbol en Clarín.";

    this.setTitle(pageTitle);
    this.setSection("Simulador Mundial");
    this.setMeta(
      this.parseMeta({
        description: pageDescription,
        keywords: "mundial, simulador, fútbol, clarín",
        title: pageTitle,
        url: "simulador-mundial",
        extra: [],
      })
    );

    this.setData({
      iframeUrl: resolveIframeUrl(),
    });
  };
}
